/**
 * UI theme (doc 17 §8). The UI layer has its own small palette, deliberately
 * separate from the world's depth palettes: panels must look the same at every
 * depth, and semantic colour must never collide with a building's signature.
 */

import { SEMANTIC } from '../render/palette.ts';
import { hex } from '../render/surface.ts';

export const UI = {
  panelFill: hex('#0a1c24'),
  panelFillHi: hex('#102933'),
  panelRimLight: hex('#3f7180'),
  panelRimDark: hex('#03090c'),
  shadow: hex('#010405'),
  ink: SEMANTIC.ink,
  inkDim: SEMANTIC.inkDim,
  accent: hex('#5ff2c8'),
  good: SEMANTIC.good,
  warning: SEMANTIC.warning,
  critical: SEMANTIC.critical,
  disabled: hex('#243c44'),
} as const;

/** Doc 17 §8: everything in the UI is a multiple of 4 UI px. Nothing by eye. */
export const GRID = 4;

export function g(units: number): number {
  return units * GRID;
}
